import React, { useRef, useEffect, useState } from 'react';

const RestaurantSelectionStep = ({ 
    restaurant,
    setRestaurant,
    allRestaurants,
    filteredRestaurants,
    setFilteredRestaurants,
    showSuggestions,
    setShowSuggestions,
    selectedSuggestionIndex,
    setSelectedSuggestionIndex,
    restaurantNotFound,
    setRestaurantNotFound,
    handleRestaurantInputChange,
    handleRestaurantKeyDown,
    handleSuggestionClick,
    diningLocation,
    onNext,
    onBack
}) => {
    const containerRef = useRef(null);
    const [suggestionDirection, setSuggestionDirection] = useState('down');
    
    useEffect(() => {
        if (showSuggestions && containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            const suggestionsHeight = Math.min(200, filteredRestaurants.length * 50); // Estimate
            
            if (spaceBelow < suggestionsHeight && spaceAbove > suggestionsHeight) {
                setSuggestionDirection('up');
            } else {
                setSuggestionDirection('down');
            }
        }
    }, [showSuggestions, filteredRestaurants]);

    const restaurantQuestion = "So, what restaurant are we going to this evening?";

    return (
        <div className="step-container">
            <h2>{restaurantQuestion}</h2>
            <div className="relative-container" ref={containerRef}>
                <div className="restaurant-dropdown-container">
                        <input
                            type="text"
                            className="restaurant-dropdown-input"
                            placeholder="Enter restaurant name or click arrow to see all"
                            value={restaurant}
                            onChange={handleRestaurantInputChange}
                            onKeyDown={handleRestaurantKeyDown}
                            onBlur={() => setTimeout(() => setShowSuggestions(false), 100)}
                            onFocus={() => {
                                // Show all restaurants when focused if input is empty
                                if (restaurant.trim() === '') {
                                    setShowSuggestions(true);
                                    setFilteredRestaurants(allRestaurants);
                                } else if (filteredRestaurants.length > 0) {
                                    setShowSuggestions(true);
                                }
                            }}
                        />
                        <button
                            type="button"
                            className="restaurant-dropdown-arrow"
                            onClick={() => {
                                // Toggle showing all restaurants
                                if (showSuggestions) {
                                    setShowSuggestions(false);
                                } else {
                                    setFilteredRestaurants(allRestaurants);
                                    setShowSuggestions(true);
                                }
                            }}
                            onMouseDown={(e) => e.preventDefault()} // Prevent input blur
                        >
                            ▼
                        </button>
                </div>

                {showSuggestions && filteredRestaurants.length > 0 && (
                    <ul className={`suggestions-list ${suggestionDirection === 'up' ? 'upward' : ''}`}>
                        {filteredRestaurants.map((restaurantName, index) => (
                            <li
                                key={restaurantName}
                                className={`suggestion-item ${index === selectedSuggestionIndex ? 'selected' : ''}`}
                                onClick={() => handleSuggestionClick(restaurantName)}
                                onMouseDown={(e) => e.preventDefault()} // Prevent input blur when clicking a suggestion
                            >
                                {restaurantName}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            {restaurantNotFound && restaurant.trim() !== '' && (
                <p className="message-text new-restaurant-message">
                    "{restaurant}" not found. It will be logged as a new restaurant.
                </p>
            )}

            <div className="navigation-buttons">
                <button onClick={onBack}>Back</button>
                <button onClick={onNext}>Next</button>
            </div>
        </div>
    );
};

export default RestaurantSelectionStep;
